import router from "./router";
import { Message } from "element-ui";
import getPageTitle from "@/utils/get-page-title";

const whiteList = ["/login"]; // 不需要重定向的白名单

// 解决多标签时 SessionStorage 共享：只注册一次，避免每次路由切换叠加监听导致越来越卡
(function setupSessionStorageShare() {
  if (!sessionStorage.length) {
    localStorage.setItem("getSessionStorage", Date.now());
  }

  window.addEventListener("storage", function (event) {
    if (event.key == "getSessionStorage") {
      localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
      localStorage.removeItem("sessionStorage");
    } else if (event.key == "sessionStorage" && !sessionStorage.length) {
      var data = JSON.parse(event.newValue);
      for (let key in data) {
        sessionStorage.setItem(key, data[key]);
      }
    }
  });
})();

router.beforeEach(async (to, from, next) => {
  if (to.matched.length == 0) {
    next({ path: "/404" });
    return;
  }

  // 设置页面标题
  document.title = getPageTitle(to.meta.title);

  // 判断用户是否已经登录
  let hasToken = sessionStorage.getItem("token");
  let isLogin = sessionStorage.getItem("isLogin");
  if (hasToken && isLogin) {
    if (to.path === "/login") {
      // 如果已登录，则重定向到主页
      next({ path: "/" });
    } else {
      try {
        next();
      } catch (error) {
        // 删除令牌并转到登录页面重新登录
        sessionStorage.clear();
        Message.error(error || "有错误");
        next(`/login?redirect=${to.path}`);
      }
    }
  } else {
    // 没有令牌
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免费登录白名单，直接去
      next();
    } else {
      // 其他没有访问权限的页面被重定向到登录页面。
      next(`/login?redirect=${to.path}`);
    }
  }
});

router.afterEach(() => { });
